import { gql } from '@apollo/client';

export const CREATE_COMPONENT = gql`
	mutation createComponent($createComponentInput: CreateComponentInput!) {
		createComponent(createComponentInput: $createComponentInput) {
			id
			slug
			data
		}
	}
`;

export const UPDATE_COMPONENT = gql`
	mutation UpdateComponent($updateComponentInput: UpdateComponentInput!) {
		updateComponent(updateComponentInput: $updateComponentInput) {
			id
		}
	}
`;

export const UPDATE_MANY_COMPONENTS_POSITION = gql`
	mutation UpdateManyComponentsPosition(
		$updateManyComponentsPosition: [UpdateComponentsPositionDto!]!
	) {
		updateManyComponentsPosition(
			updateManyComponentsPosition: $updateManyComponentsPosition
		)
	}
`;

export const REMOVE_COMPONENT = gql`
	mutation removeComponent(
		$id: String!
		$pageSlug: String!
		$languageSlug: String!
	) {
		removeComponent(id: $id, pageSlug: $pageSlug, languageSlug: $languageSlug)
	}
`;

export const REMOVE_PAGE_GROUP = gql`
	mutation RemovePageGroup($id: String!) {
		removePageGroup(id: $id)
	}
`;

export const CREATE_PAGE_GROUP = gql`
	mutation CreatePageGroup($createPageGroupInput: CreatePageGroupInput!) {
		createPageGroup(createPageGroupInput: $createPageGroupInput) {
			id
			name
			reference_id
			clicks
			guidance_type
			type
			countdown
			size
			round_shape
			is_full_width_banner
			schedule_start
			schedule_end
			items {
				id
				name
				text_color
				background_color
				image_description
			}
			display {
				element_id
				slug
				name
			}
		}
	}
`;

export const UPDATE_PAGE_GROUP_POSITION = gql`
	mutation UpdatePageGroupPosition(
		$updatePageGroupInput: UpdatePageGroupInput!
	) {
		updatePageGroup(updatePageGroupInput: $updatePageGroupInput) {
			id
		}
	}
`;

export const UPDATE_PAGE_GROUP = gql`
	mutation UpdatePageGroup($updatePageGroupInput: UpdatePageGroupInput!) {
		updatePageGroup(updatePageGroupInput: $updatePageGroupInput) {
			id
		}
	}
`;

export const CREATE_GROUP_ELEMENT = gql`
	mutation CreateGroupElement(
		$createGroupElementInput: CreateGroupElementInput!
	) {
		createGroupElement(createGroupElementInput: $createGroupElementInput) {
			id
			name
			description
			page_group_id
			element_id
			file_id
			background_color
			image_description
			redirect_value
			redirect_data
			facets
			image_align
			weight
			file {
				url
			}
			text_color
		}
	}
`;

export const UPDATE_GROUP_ELEMENT = gql`
	mutation UpdateGroupElement(
		$updateGroupElementInput: UpdateGroupElementInput!
	) {
		updateGroupElement(updateGroupElementInput: $updateGroupElementInput) {
			id
			name
			description
			redirect_value
			redirect_type
			redirect_data
			image_align
			weight
			file {
				url
			}
		}
	}
`;

export const REMOVE_GROUP_ELEMENT = gql`
	mutation RemoveGroupElement($id: String!) {
		removeGroupElement(id: $id)
	}
`;

export const UPDATE_GROUP_ELEMENT_POSITION = gql`
	mutation UpdateGroupElementPosition(
		$updateGroupElementInput: UpdateGroupElementInput!
	) {
		updateGroupElement(updateGroupElementInput: $updateGroupElementInput) {
			id
		}
	}
`;

export const UPDATE_CATEGORY = gql`
	mutation UpdateCategory($updateCategoryInput: UpdateCategoryInput!) {
		updateCategory(updateCategoryInput: $updateCategoryInput) {
			id
		}
	}
`;

export const CREATE_PAGE = gql`
	mutation createPage($createPageInput: CreatePageInput!) {
		createPage(createPageInput: $createPageInput) {
			id
			name
			slug
			show_tab_bar
			header_type
			background_color
			secondary_color
			contrast_color
			start_date
			end_date
		}
	}
`;

export const REMOVE_PAGE = gql`
	mutation removePage($id: String!) {
		removePage(id: $id)
	}
`;

export const UPDATE_PAGE = gql`
	mutation updatePage($updatePageInput: UpdatePageInput!) {
		updatePage(updatePageInput: $updatePageInput) {
			id
			name
			slug
			show_tab_bar
			header_type
			background_color
			secondary_color
			contrast_color
			start_date
			end_date
		}
	}
`;

export const CREATE_INTEGRATION = gql`
	mutation createIntegration($createIntegrationInput: CreateIntegrationInput!) {
		createIntegration(createIntegrationInput: $createIntegrationInput) {
			name
			credentials
		}
	}
`;

export const REMOVE_INTEGRATION = gql`
	mutation removeIntegration($id: String!) {
		removeIntegration(id: $id)
	}
`;
